import { Button } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { ReactComponent as SuccessIcon } from "@/assets/icons/success.svg";

const PasswordResetSuccess: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="forgotten-password-container">
      <div className="forgotten-password-card success-card">
        <div className="forgotten-password-content">
          <div className="flex justify-center">
            <SuccessIcon className="text-[#004A99]" />
          </div>
          <div className="text-[#0b1a29] text-center text-xl font-bold">
            Lozinka uspješno kreirana
          </div>
        </div>
        <div className="forgotten-password-button-container">
          <Button
            variant="filled"
            color="#004a99"
            radius="xl"
            size="md"
            className="flex-1 !h-[3.25rem]"
            onClick={() => navigate("/login")}
          >
            Nastavi na prijavu
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PasswordResetSuccess;
